import { render } from "./FasSort.vue?vue&type=template&id=52c2877e"
import script from "./FasSort.vue?vue&type=script&lang=js"
export * from "./FasSort.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__